import { useState, useEffect } from "react";
import { Col, Container, Row, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import TabComponent from "../../common/TabComponent";
import { apiService } from "../../service/api.service";
import { getStatus, FilterStatus } from "../../config/config";
import moment from "moment";
import BarChart from "../../common/Graph";

const SalesWatermarkIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="29" stroke="currentColor" strokeWidth="3" />
    <path
      d="M32 15v34M39 23c0-3.3-3.4-5.8-7.4-5.8S24.2 19.6 24.2 23s3.4 4.6 7.4 5.4c4.9.9 8.4 2.7 8.4 6.3S36 41 31.6 41s-8-2.3-8-5.7"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

const OrdersWatermarkIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 22h38l-3.3 31.4a4.5 4.5 0 0 1-4.5 4.1H20.8a4.5 4.5 0 0 1-4.5-4.1L13 22Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M22 22v-5a10 10 0 0 1 20 0v5"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

const ProductsWatermarkIcon = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 6 57 18.5v27L32 58 7 45.5v-27Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M7 18.5 32 31l25-12.5M32 31v27"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

const Dashboard = () => {
  const [orders, setorderData] = useState();
  const [orderCounts, setorderCounts] = useState();
  const [labels, setlabels] = useState([]);
  const [values, setvalues] = useState([]);
  useEffect(() => {
    getOrdersDashboard();
    getCountDashboard();
  }, []);
  const tooltip = <Tooltip id="tooltip">View Detail</Tooltip>;
  const getOrdersDashboard = () => {
    apiService
      .getOrdersDashboard()
      .then((res) => {
        setorderData(res.data.data.list);
      })
      .catch((err) => {
        // setLoader(false)
        //  errorHandling(err.response.status)

        // console.log(err)
        console.log("contact us api error", err.response);
      });
  };
  const getCountDashboard = () => {
    apiService
      .dashboardCount()
      .then((res) => {
        console.log(res.data.data);
        setorderCounts(res.data.data.counts);
        const newValues = [];
        const newLabels = [];
        res.data.data.counts.earningGraph.map((data)=>{
         
          newValues.push(data.value);
        

 
          // Update the state with the new array
        
      
        
          console.log("=====data.newValues====,",data.
          label
          )

          newLabels.push(data.label);
         
          console.log("=====newLabels====,",newLabels)
          // Update the state with the new array
        
 
          
        })
        setvalues(newValues);
        setlabels(newLabels);
        //    setorderData(res.data.data.list)
      })
      .catch((err) => {
        // setLoader(false)
        //  errorHandling(err.response.status)

        // console.log(err)
        console.log("contact us api error", err.response);
      });
  };

  const graphData = [
    { label: "January", value: 20 },
    { label: "February", value: 25 },
    { label: "March", value: 30 },
    { label: "April", value: 35 },
    { label: "May", value: 20 },
    { label: "June", value: 25 },
    { label: "July", value: 30 },
    { label: "August", value: 35 },
    { label: "September", value: 20 },
    { label: "October", value: 25 },
    { label: "November", value: 30 },
    { label: "December", value: 35 },
  ];

  const getStatusClass = (status) => {
    if (status === "Pending") return "pending";
    if (status === "Order Delivered") return "";
    if (status === "Order Cancelled") return "pending";
    if (status === "Driver Not Assigned") return "not-assigned";
    if (status === "Driver Assigned") return "driver-assigned";
    return "accepted";
  };

  return (
    <>
      <div className="height-footer dashboard-page">
        <Container>
          <div className="dashboard-shell">
            <div className="dashboard-sidebar">
              <TabComponent />
            </div>
            <div className="dashboard-main">
              <div className="tab-pane" id="dashboard">
                <div className="dashboard-management common-under-padding">
                  <h2 className="subheading-under dashboard-title mb-4">
                    Dashboard
                  </h2>
                  <div className="boxes-section">
                    <Row className="g-3">
                      <Col sm={4}>
                        <div className="dashboard-card">
                          <div className="dashboard-card-watermark">
                            <SalesWatermarkIcon />
                          </div>
                          <div className="dashboard-card-content">
                            <div className="dashboard-card-icon">
                              <img
                                className=""
                                src={
                                  require("../../assets/images/badge-1.svg")
                                    .default
                                }
                                alt="img"
                              />
                            </div>
                            <h5>Total Sales</h5>
                            <h3 className="dashboard-txt">
                              {orderCounts ? (
                                `$${(orderCounts.sales ?? 0).toLocaleString()}`
                              ) : (
                                <span className="skeleton-loader" />
                              )}
                            </h3>
                          </div>
                        </div>
                      </Col>
                      <Col sm={4}>
                        <div className="dashboard-card dashboard-card2">
                          <div className="dashboard-card-watermark">
                            <OrdersWatermarkIcon />
                          </div>
                          <div className="dashboard-card-content">
                            <div className="dashboard-card-icon">
                              <img
                                className=""
                                src={
                                  require("../../assets/images/badge-2.svg")
                                    .default
                                }
                                alt="img"
                              />
                            </div>
                            <h5>Total Orders</h5>
                            <h3 className="dashboard-txt">
                              {orderCounts ? (
                                (orderCounts.orders ?? 0).toLocaleString()
                              ) : (
                                <span className="skeleton-loader" />
                              )}
                            </h3>
                          </div>
                        </div>
                      </Col>
                      <Col sm={4}>
                        <div className="dashboard-card dashboard-card3">
                          <div className="dashboard-card-watermark">
                            <ProductsWatermarkIcon />
                          </div>
                          <div className="dashboard-card-content">
                            <div className="dashboard-card-icon">
                              <img
                                className=""
                                src={
                                  require("../../assets/images/badge-3.svg")
                                    .default
                                }
                                alt="img"
                              />
                            </div>
                            <h5>Total Products</h5>
                            <h3 className="dashboard-txt">
                              {orderCounts ? (
                                (orderCounts.products ?? 0).toLocaleString()
                              ) : (
                                <span className="skeleton-loader" />
                              )}
                            </h3>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="graph-section">
                    <div>
                      <BarChart labels={labels} values={values} />
                    </div>
                    {/* graph here added */}
                  </div>
                  <div className="order-section">
                    <h5 className="latest-order-txt">Pending Orders</h5>
                    {/* project management table start */}
                    <div className="table-data">
                      <table className="table dashboard-orders-table">
                        <thead>
                          <tr>
                            <th>Order Id</th>
                            <th>Ordered Date</th>
                            <th>Customer Name</th>
                            <th>Driver Name</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders &&
                            orders.map((data, i) => {
                              let status = getStatus(data.status);

                              return (
                                <tr key={data.orderId ?? i}>
                                  <td>#{data.orderId}</td>

                                  <td>
                                    {moment(data.orderDate).format(
                                      "DD MMM, YYYY"
                                    )}
                                  </td>
                                  <td>{data.customer.fullName}</td>
                                  <td>
                                    {data.driverName ? data.driverName : "N/A"}
                                  </td>

                                  <td>
                                    <span
                                      className={`status-badge delivered ${getStatusClass(
                                        status
                                      )}`}
                                    >
                                      {status}
                                    </span>
                                  </td>
                                  <td>${data.totalAmount}</td>
                                  <td>
                                    <div className="action-data-box">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={tooltip}
                                      >
                                        <Link
                                          to={
                                            "/order-mangement/order-details/" +
                                            data.orderId
                                          }
                                        >
                                          <img
                                            className=""
                                            src={
                                              require("../../assets/images/eye (2).svg")
                                                .default
                                            }
                                            alt="img"
                                          />
                                        </Link>
                                      </OverlayTrigger>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {orders && orders.length == 0 && (
                        <div className="nodata centre">
                          <img
                            className=""
                            src={require("../../assets/images/no-data-found.png")}
                            alt="img"
                          />
                          <span>No data Found</span>
                        </div>
                      )}
                    </div>
                    {/* project management table end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Dashboard;
